module.exports = {
	"service_taxes": {
		"attributes": {
			"authenticity_code": "ID",
			"id": "ID",
			"created_at": "Data",
			"url_invoice": "URL da nota",
			"statuses": {
				"issued": "Emitida",
				"created": "Aguardando Emissão NFE.io",
				"canceled": "Cancelada",
				"error": "Falha ao emitir",
				"pending_issued": "Aguardando Emissão",
				"pending_cancel": "Pendente Cancelamento"
			}
		},
		"messages": {
			"not_generated": "Não gerada",
			"nf": "Nota Fiscal"
		},
		"tags": {
			"issued": "ls-tag-primary",
			"canceled": "ls-tag-danger",
			"error": "ls-tag-danger",
			"created": "ls-tag-warning",
			"pending_issued": "ls-tag-warning",
			"pending_cancel": "ls-tag-warning"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/service_taxes/pt-BR.yml
// module id = 591
// module chunks = 1